/** Iter 691 — founder's mock: grey caption line + 6-segment teal progress
 * bar (the old per-step dot stepper is gone). Teal #0E7C86 fills up to
 * the current step. */
import React from "react";

const WIZARD_CAPTIONS = [
  "1. Scan store QR",
  "2. Add a photo",
  "3. Share your photo",
  "4. Your bill at the till",
  "5. Pay",
  "6. Payment received",
];

export default function WizardBar({ step }) {
  const idx = Math.min(Math.max(step || 1, 1), 6);
  return (
    <div className="pb-3" data-testid="engage-wizard-bar">
      <p className="text-xs font-bold text-slate-500 mb-1.5" data-testid="cust-step-caption">
        {WIZARD_CAPTIONS[idx - 1]}
      </p>
      <div className="flex items-center gap-1" data-testid="cust-progress-bar">
        {Array.from({ length: 6 }, (_, i) => (
          <span
            key={i}
            className="h-1.5 flex-1 rounded-full transition-colors"
            style={{ backgroundColor: i < idx ? "#0E7C86" : "#E2E8F0" }}
          />
        ))}
      </div>
    </div>
  );
}
